import React from "react";

import {FieldWrapper, getFieldState, IFieldWrapperProps} from "@pg-design/inputs-module";
import {getErrorMessage} from "@pg-design/inputs-module/src/utils/get_error_message";
import {ISelectProps, SelectCreatable} from "@pg-design/select-module";

export type ISelectFieldProps = IFieldWrapperProps &
    ISelectProps & {
        error?: string | string[];
    };

export const SelectCreatableField = (props: ISelectFieldProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {labelContent, message, id, className, error, ...selectProps} = props;

    const fieldState = getFieldState(props);
    const errorMessage = getErrorMessage(props.error);

    return (
        <FieldWrapper labelContent={labelContent} fieldState={fieldState} message={errorMessage || message} htmlFor={id} className={className}>
            {/*@ts-ignore*/}
            <SelectCreatable {...selectProps} />
        </FieldWrapper>
    );
};
import React from "react";

import {FieldWrapper, getFieldState, IFieldWrapperProps} from "@pg-design/inputs-module";
import {getErrorMessage} from "@pg-design/inputs-module/src/utils/get_error_message";
import {ISelectProps, SelectCreatable} from "@pg-design/select-module";

export type ISelectFieldProps = IFieldWrapperProps &
    ISelectProps & {
        error?: string | string[];
    };

export const SelectCreatableField = (props: ISelectFieldProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {labelContent, message, id, className, error, ...selectProps} = props;

    const fieldState = getFieldState(props);
    const errorMessage = getErrorMessage(props.error);

    return (
        <FieldWrapper labelContent={labelContent} fieldState={fieldState} message={errorMessage || message} htmlFor={id} className={className}>
            {/*@ts-ignore*/}
            <SelectCreatable {...selectProps} />
        </FieldWrapper>
    );
};
